'use client'

import { ReactElement, useEffect, useState } from 'react'
import { Switch } from '@repo/ui/components/switch'
import {
  formatAmountForDisplay,
  formatAmountForDisplayTrunk,
} from '@/utils/stripe-helpers'
import { CURRENCY } from '@/config'
import {
  selectedUpSellingSelector,
  setUpsellingSelector,
} from '@/hooks/use-cart-product/selectors'
import { useProductStore } from '@/hooks/use-cart-product/store'
import { useTracking } from '@/hooks/use-tracking'

export type UpSellingProps = {
  priceId: string
  savingAmount: number
  description: string
  price: number
  txtSidePrice: string
}

export function UpSelling({
  priceId,
  savingAmount,
  description,
  price,
  txtSidePrice,
}: UpSellingProps): ReactElement {
  const upsellingSelected = useProductStore(selectedUpSellingSelector)
  const setUpselling = useProductStore(setUpsellingSelector)
  const [isCheck, setCheck] = useState<boolean>(false)
  const tracking = useTracking()

  useEffect(() => {
    setCheck(upsellingSelected === priceId)
  }, [upsellingSelected, priceId])

  const handleChangeSubscription = (active: boolean) => {
    active ? setUpselling(priceId) : setUpselling('')

    tracking.trackEvent({
      eventName: 'upselling_checkbox',
      parameters: { active_upselling: active },
    })
  }

  return (
    <div className="flex flex-row rounded-b-md border border-[#406FDA] bg-[#EEF1FF] p-2 py-4 text-body-small text-admin-grey-500">
      <div className="w-full">
        <div className="flex flex-row items-center space-x-2">
          <Switch
            checked={isCheck}
            defaultChecked={false}
            onCheckedChange={handleChangeSubscription}
          />
          <p className="text-checkout-xs pr-4 font-medium text-[#121316]">
            <span className="text-checkout-xs bg-checkout-green-light rounded-md px-2 py-0.5 font-medium text-[#121316]">
              Ahorra {formatAmountForDisplayTrunk(savingAmount, CURRENCY)}
            </span>{' '}
            {description}
          </p>
        </div>
      </div>

      <div className="ml-2 flex w-1/3 flex-col items-end">
        <p className="text-checkout-xs font-medium text-[#121316]">
          {formatAmountForDisplay(price, CURRENCY)}/{txtSidePrice}
        </p>
      </div>
    </div>
  )
}
